import logoIcon from '../../assets/images/auth/konekt_icon.png';

const LogoIcon = () => {
  return <img src={logoIcon} alt="icon logo" width="50" />;
};

export default LogoIcon;
